function formatNumber (n) {
    n = n.toString()
    return n[1] ? n : '0' + n
  }
  // 时间格式化
  function formatTime (date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
   
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  }
 
  function formatDate( date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return [year, month, day].map(formatNumber).join('-')  
  }
  function strToYeayAndMonth(str)
  {
    var dt = Date.parse(str);
    var date  =new Date(dt);
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    return [year, month].map(formatNumber).join('-')
  }
  function strToFormatDate(str)
  {
    var dt = Date.parse(str);
  
      return formatDate(new Date(dt));
  }
  export {formatDate ,formatNumber, formatTime,strToFormatDate,strToYeayAndMonth};
 